import { Stack, Typography } from '@mui/material'

import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  description: string | null
  companyName: string
}

const OverviewTab: React.FC<Props> = ({ description, companyName }) => {
  const { t } = useTranslation()

  return (
    <Stack direction="column" spacing={1}>
      <Typography variant="subtitle3">{t('cc:Overview')}</Typography>
      <Typography variant="body2" whiteSpace="pre-wrap">
        {description || t('cc:dialogTabs.waitingForInfo', { companyName })}
      </Typography>
    </Stack>
  )
}

export default OverviewTab
